import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { statusDictionary } from '@/Ship/Components/Filters/StatusFilterBar'
import { StatusTag } from '@/Ship/Components/StatusTag'

/**
 * Бейдж статусу з довідника за кодом — для підказок (`SPEC-022` §12): статус у
 * тексті подається бейджем, а не назвою в лапках (вартовий підказок).
 *
 * Назву й колір статусу запиту змінює адміністратор у довіднику, тож вписати
 * їх у текст не можна — бейдж бере їх із того самого довідника, що рядок
 * статусів і колонка. Поки довідник не прийшов — код статусу.
 */
export const DictionaryStatusTag = observer(({ resource, code }: { resource: string; code: string }) => {
    const dictionary = statusDictionary(resource)

    useEffect(() => {
        if (!dictionary.isLoaded) void dictionary.refresh()
    }, [dictionary])

    const option = dictionary.options.find((item) => item.value === code)

    return <StatusTag label={option?.label ?? code} color={option?.color} inline />
})
